
import React from 'react';
import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";

interface PhoneNameMismatchDialogProps {
  isOpen: boolean;
  onClose: () => void;
  existingName: string;
  newName: string;
  onContinueWithNew: () => void;
  onChangePhone: () => void;
}

export const PhoneNameMismatchDialog: React.FC<PhoneNameMismatchDialogProps> = ({
  isOpen,
  onClose,
  existingName,
  newName,
  onContinueWithNew,
  onChangePhone
}) => {
  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="max-w-md rounded-md">
        <DialogHeader>
          <DialogTitle>Name Mismatch</DialogTitle>
          <DialogDescription>
            This phone number is already associated with <strong>{existingName}</strong>, but 
            you selected <strong>{newName}</strong>.
          </DialogDescription>
        </DialogHeader>
        
        <div className="py-2 text-sm text-muted-foreground">
          Please choose how you want to proceed:
        </div>
        
        <DialogFooter className="flex flex-col space-y-2 sm:space-y-0">
          <Button onClick={onContinueWithNew} className="w-full">
            Continue as {existingName}
          </Button>
          <Button variant="outline" onClick={onChangePhone} className="w-full">Change number</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
